import { getQueryStringParameter } from '../../helpers';

const formatConfirmationString = (string) => {
  return string.normalize('NFD').replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
}

const setFormSubmitButtonState = ($form) => {
  const $submitButton = $("input[type='submit']", $form);
  let $termsAcceptedValue = $('#subscription_terms_accepted', $form)[0].checked;
  let $guaranteeValidInformationValue = $('#subscription_guarantee_valid_information', $form)[0].checked;

  let $invalidText = $('#confirmation-input', $form).filter((_, element) => {
    return !$(element).hasClass('is-valid');
  });

  if ($invalidText.length === 0 && $termsAcceptedValue && $guaranteeValidInformationValue) {
    $submitButton.removeAttr('disabled');
  } else {
    $submitButton.attr('disabled', 'disabled');
  }
};

const validateConfirmation = ($form) => {
  const $confirmationLabel = $('#confirmation-label', $form);
  const $confirmationInput = $('#confirmation-input', $form);
  const $confirmationWarning = $('#confirmation-warning', $form);

  if (formatConfirmationString($confirmationInput.val().trim()) === formatConfirmationString($confirmationLabel.text())) {
    $confirmationWarning.addClass('d-none');
    $confirmationInput.removeClass('is-invalid');
    $confirmationInput.addClass('is-valid');
  } else {
    $confirmationWarning.removeClass('d-none');
    $confirmationInput.addClass('is-invalid');
    $confirmationInput.removeClass('is-valid');
  }

  setFormSubmitButtonState($form);
};


$(() => {
  const $form = $('form#subscription-form');
  const step = getQueryStringParameter('id');

  if ($form.length === 0 || (step !== null && step !== '' && step !== 'signature')) {
    return;
  }

  const $confirmationLabel = $('#confirmation-label', $form);
  const $confirmationInput = $('#confirmation-input', $form);

  const $termsAccepted = $('#subscription_terms_accepted', $form);
  const $guaranteeValidInformation = $('#subscription_guarantee_valid_information', $form);

  $confirmationInput.on('input', (e) => {
    validateConfirmation($form);

    $(e.target).change();
  });

  $termsAccepted.on('input', (_e) => {
    setFormSubmitButtonState($form);
  });

  $guaranteeValidInformation.on('input', (_e) => {
    setFormSubmitButtonState($form);
  });
});
